var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBottom = function SvgBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 117 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D26E00",
    d: "M48.553 1.106A2 2 0 0 0 46.763 0H3.237a2 2 0 0 0-1.789 2.894l33 66A2 2 0 0 0 36.237 70h43.527a2 2 0 0 0 1.789-2.894z"
  })));
};
export default SvgBottom;